import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/organizations';
import { ResultState } from '@rootCommon/types/common';
import { Organization } from '@rootCommon/types/organization';

type Action = ActionType<typeof actions>;
export type OrganizationTitleState = ResultState<Pick<Organization, 'title'> | null>;

const initState: OrganizationTitleState = {
  data: null,
  loading: false,
  error: null,
};

export const organizationTitleReducer = (state = initState, action: Action): OrganizationTitleState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchOrganizationTitle.request):
      return { ...state, loading: true, error: null };
    case getType(actions.fetchOrganizationTitle.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchOrganizationTitle.failure):
      return { ...state, loading: false, error: action.payload };

    // default
    default:
      return state;
  }
};

export default organizationTitleReducer;
